import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  summaryButton: {
    backgroundColor: theme.palette.common.black
  },
  barChartIcon: {
    marginRight: theme.spacing(1)
  },
  image: {
    width: '100%',
    maxHeight: 400
  }
}));

function Header({ className, AtananIsler,title, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  let TeknAdet = 0;
  if (AtananIsler != undefined && AtananIsler?.length !== 0) {
    const TeknisyendeData = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(21));
    TeknAdet = TeknisyendeData.length;
  }
  const SessionUser = getUser();
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        container
        justify="space-between"

        spacing={3}
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {t('Merhaba')}
            ,
            {' '}
            {SessionUser.FirstName}
            {' '}
            {SessionUser.LastName}

          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
          >
            {/* {
              (TeknAdet === 0)
                ? <div />
                : (
                  <div>
                     {t('isler_header').replace('@adet', TeknAdet)} <br/>
                  </div>
                )
            }*/}
            {
              <div>   
                {title}
              </div>
            }

          </Typography>
        </Grid>
      </Grid>

    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
